import React from 'react'
import { CInput } from 'app/components/Common/'
import { useTranslation } from 'react-i18next'
import { InputContainer } from './styles'
import PhoneInputSection from './PhoneInputSection'
interface IProps {
	type: string
	id: string
	setId: (params?: any) => void
	password: string
	setPassword: (params?: any) => void
	onKeyWown?: (params?: any) => void
}

const InputSection = ({ type, id, setId, password, setPassword,onKeyWown }: IProps) => {
	const { t } = useTranslation()
	const onChangeId = e => {
		setId(e.target.value)
	}
	const onChangePassword = e => {
		setPassword(e.target.value)
	}

	return (
		<InputContainer>
			{type === 'phone' ? (
				<PhoneInputSection
					id={id}
					onChangeId={onChangeId}
					type={type}
				/>
			) : (
				<CInput
					placeholder={'아이디'}
					value={id}
					type={'text'}
					onChange={onChangeId}
					style={{ 
						border: 'none', 
						fontSize: 14,
						color: '#ffffff',
						backgroundColor: 'transparent'
					}}
				/>
			)}

			<CInput
				placeholder={t('password')}
				value={password}
				type={'password'}
				onChange={onChangePassword}
				onKeyDown={onKeyWown}
				style={{
					border: 'none',
					borderRadius: 5,
					fontSize: 14,
					color: '#ffffff',
					backgroundColor: 'transparent'
				}}
			/>
		</InputContainer>
	)
}

export default React.memo(InputSection)
